// Arabic translations for Transactions Page
const arTransactionsPage = {
    transactions: {
      title: 'المعاملات',
      subtitle: 'عرض وتحليل جميع معاملات العملاء',
      
      stats: {
        totalTransactions: 'إجمالي المعاملات',
        totalRevenue: 'إجمالي الإيرادات',
        totalPoints: 'إجمالي النقاط الصادرة',
        averageOrder: 'متوسط قيمة الطلب'
      },
      
      filter: {
        title: 'تصفية المعاملات',
        dateRange: {
          label: 'النطاق الزمني',
          options: {
            all: 'كل الفترات',
            today: 'اليوم',
            yesterday: 'الأمس',
            week: 'آخر 7 أيام',
            month: 'آخر 30 يوم',
            custom: 'فترة مخصصة'
          },
        
          start: 'تاريخ البداية',
          end: 'تاريخ النهاية'
        },
        status: {
          label: 'النوع',
          options: {
            all: 'الجميع',
            active: 'فعالة',
            deleted: 'ملغية'
          },
        },
        amount: {
          min: 'الحد الأدنى للمبلغ',
          max: 'الحد الأقصى للمبلغ',
          placeholder: 'أدخل المبلغ'
        },
        customer: {
          label: 'البحث عن العميل',
          placeholder: 'الاسم أو الهاتف'
        },
        sort: {
          label: 'ترتيب حسب',
          options: {
            dateDesc: 'التاريخ (الأحدث أولاً)',
            dateAsc: 'التاريخ (الأقدم أولاً)',
            amountDesc: 'المبلغ (من الأعلى إلى الأقل)',
            amountAsc: 'المبلغ (من الأقل إلى الأعلى)',
            pointsDesc: 'النقاط (من الأعلى إلى الأقل)',
            pointsAsc: 'النقاط (من الأقل إلى الأعلى)'
          }
        },
        buttons: {
          apply: 'تطبيق التصفية',
          reset: 'إعادة تعيين'
        }
      },
      
      analytics: {
        topDays: 'أفضل أيام الأداء',
        noData: 'لا توجد بيانات متاحة للرسم البياني.',
        addTransactions: 'أضف معاملات لرؤية مقاييس الأداء اليومية.'
      },
      
      tableHeader: {
        title: 'سجل المعاملات',
        count: '{count} معاملة تم العثور عليها'
      },
      
      table: {
        date: 'التاريخ والوقت',
        customer: 'العميل',
        amount: 'المبلغ',
        points: 'النقاط',
        status: 'الحالة',
        details: 'التفاصيل',
        unknown: 'غير معروف',
        noID: 'بدون رقم تعريف'
      },
      
      status: {
        new: 'عميل جديد',
        redeem: 'استرداد',
        highValue: 'قيمة عالية',
        standard: 'عادية',
        deleted: 'ملغية',
      },
      
      actions: {
        expand: 'عرض التفاصيل',
        collapse: 'إخفاء التفاصيل'
      },
      
      expanded: {
        id: 'رقم المعاملة',
        customer: 'العميل',
        phone: 'الهاتف',
        dateTime: 'التاريخ والوقت',
        amount: 'المبلغ',
        pointsEarned: 'النقاط المكتسبة',
        type: 'النوع'
      },
      
      type: {
        first: 'أول عملية شراء',
        regular: 'عملية شراء عادية',
        standard: 'عملية شراء عادية',
      },
      
      errors: {
        noTransactions: 'لا توجد معاملات في قاعدة البيانات.',
        noValidTransactions: 'لم يتم العثور على معاملات صالحة في قاعدة البيانات.',
        fetchingFailed: 'فشل في جلب المعاملات: {message}',
        checkDatabase: 'يرجى التحقق من قاعدة بيانات Firestore والتأكد من وجود مجموعة "transactions" وتحتوي على بيانات.'
      },
      
      empty: 'لم يتم العثور على معاملات تطابق تصفيتك.',
      
      days: {
        sun: 'الأحد',
        mon: 'الإثنين',
        tue: 'الثلاثاء',
        wed: 'الأربعاء',
        thu: 'الخميس',
        fri: 'الجمعة',
        sat: 'السبت'
      }
    },
    
    common: {
      loading: 'جاري التحميل...',
      recent: 'حديثاً',
      pagination: {
        previous: 'السابق',
        next: 'التالي'
      }
    }
  };
  
  export default arTransactionsPage;